import React, { useContext } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { CopyOutlined } from '@ant-design/icons';
import message from '../message';
import AppContext from '../AppContext';
import { WAREHOUSE_ADDRESS, WAREHOUSE_PHONE, WAREHOUSE_ZIP_CODE } from '../../config';

function ShippingAddress() {
  const { user, isAuthenticated } = useContext(AppContext);
  const contact1 = (isAuthenticated && user.operator?.name) || '操作员名字';
  const contact2 = (isAuthenticated && user.code) || '你的会员号';
  const address1 = WAREHOUSE_ADDRESS;
  const address2 = `(${(isAuthenticated && user.name) || '你的名字'} ${
    (isAuthenticated && user.code) || '你的会员号'
  })`;
  const phone = (isAuthenticated && user?.operator?.phone) || WAREHOUSE_PHONE;
  const zipcode = WAREHOUSE_ZIP_CODE;
  return (
    <div>
      <p>
        <CopyToClipboard
          text={contact1 + contact2}
          onCopy={() => {
            message.success('收件人已复制');
          }}
        >
          <span>
            <CopyOutlined />
            &nbsp;收件人：{contact1}
            <span style={{ color: '#EB6841' }}>{contact2}</span>
          </span>
        </CopyToClipboard>
      </p>
      <p>
        <CopyToClipboard
          text={address1 + address2}
          onCopy={() => {
            message.success('地址已复制');
          }}
        >
          <span>
            <CopyOutlined />
            &nbsp;地址：{address1}
            <span style={{ color: '#EB6841' }}>{address2}</span>
          </span>
        </CopyToClipboard>
      </p>
      <p>
        <CopyToClipboard
          text={phone}
          onCopy={() => {
            message.success('电话已复制');
          }}
        >
          <span>
            <CopyOutlined />
            &nbsp;电话：{phone}
          </span>
        </CopyToClipboard>
      </p>
      <p>
        <CopyToClipboard
          text={zipcode}
          onCopy={() => {
            message.success('邮编已复制');
          }}
        >
          <span>
            <CopyOutlined />
            &nbsp;邮编：{zipcode}
          </span>
        </CopyToClipboard>
      </p>
      <p>
        注意：收件人要写操作员名字+会员号，便于及时入库。如果收件人超长，可以去掉会员号；如果地址超长，可以去掉名字和会员号。划重点：
        <i style={{ textDecoration: 'underline' }}>整个地址里一定要出现会员号</i>
      </p>
    </div>
  );
}

export default ShippingAddress;
